import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import { Contract } from '@/types/ContractType';

const PlannedCommunity = ({ contract }: { contract: Contract }) => {
  const rawDays = contract?.thirdPartyInspection?.negotiationDaysFromDiscovery;
  const parsedDays = Number(rawDays);
  const daysLabel =
    Number.isFinite(parsedDays) && parsedDays > 0 ? String(parsedDays) : '____';

  return (
    <View style={styles.section}>
      <Text style={styles.title}>
        Planned Community/Homeowners Association Notice
      </Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1.{' '}
          <Text style={styles.bold}>
            Homeowner's Association/Community Disclosure:
          </Text>{' '}
          Buyer should not execute this contract until buyer has received and
          read the Homeowners' Association/Community Disclosure, if applicable.
        </Text>

        <Text style={styles.listItem}>
          2. Planned Community (Homeowner Association). The Property is part of
          a planned community, Seller to furnish Buyer with a copy of the
          declaration (other than plats and plans), the bylaws, the rules and
          regulations of the association, and a Certificate.
        </Text>

        <Text style={styles.listItem}>
          3. If this is the first sale of the property after creation of the
          condominium or planned community (therefore a sale by the Declarant),
          Seller shall furnish Buyer with a Public Offering Statement no later
          than the date Buyer executes this Agreement. Buyer may void this
          Agreement <Text style={styles.InfoText}>within 15 days</Text> (if a
          condominium) or <Text style={styles.InfoText}>within 7 days</Text> (if
          part of a planned community) after receipt of the Public Offering
          Statement or any amendment to the Statement that materially and
          adversely affects Buyer. Upon{' '}
          <Text style={styles.DangerText}>
            Buyer declaring this Agreement void
          </Text>
          ,{' '}
          <Text style={styles.DangerText}>
            all deposit money will be returned to Buyer according to the terms
            of this Agreement
          </Text>
          .
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.InfoText}>Within {daysLabel} days</Text> from
          the <Text style={styles.bold}>Execution Date</Text> of this Agreement,{' '}
          <Text style={styles.bold}>Seller</Text>, at Seller's expense, will
          request from the association a{' '}
          <Text style={styles.bold}>Certificate of Resale</Text> and any other
          documents necessary to enable <Text style={styles.bold}>Seller</Text>{' '}
          to comply with the relevant <Text style={styles.bold}>Act</Text>.
          Among certain states, the association is required to provide these
          documents <Text style={styles.InfoText}>within 10 days</Text> of{' '}
          <Text style={styles.bold}>Seller's</Text> request.{' '}
          <Text style={styles.bold}>Seller</Text> will promptly deliver to{' '}
          <Text style={styles.bold}>Buyer</Text> all documents received from the
          association. Under the <Text style={styles.bold}>Act</Text>,{' '}
          <Text style={styles.bold}>Seller</Text> is not liable to{' '}
          <Text style={styles.bold}>Buyer</Text> for the failure of the
          association to provide the{' '}
          <Text style={styles.bold}>Certificate</Text> in a timely manner or for
          any incorrect information provided by the association in the{' '}
          <Text style={styles.bold}>Certificate</Text>. The{' '}
          <Text style={styles.bold}>Act</Text> provides that{' '}
          <Text style={styles.bold}>Buyer</Text> may declare this Agreement{' '}
          <Text style={styles.DangerText}>VOID</Text> at any time before{' '}
          <Text style={styles.bold}>Buyer</Text> receives the association
          documents and{' '}
          <Text style={styles.InfoText}>for 5 days after receipt</Text>, OR
          until settlement, whichever occurs first.{' '}
          <Text style={styles.InfoText}>
            Buyer's notice to Seller must be in writing
          </Text>{' '}
          upon{' '}
          <Text style={styles.DangerText}>
            Buyer declaring this Agreement void
          </Text>
          ,{' '}
          <Text style={styles.DangerText}>
            all deposit money will be returned to Buyer according to the terms
            of this Agreement
          </Text>
          .
        </Text>

        <Text style={styles.listItem}>
          5. If the association has the right to buy the{' '}
          <Text style={styles.bold}>Property</Text> (
          <Text style={styles.bold}>right of first refusal</Text>), and the
          association exercises that right,{' '}
          <Text style={styles.bold}>Seller</Text> will reimburse{' '}
          <Text style={styles.bold}>Buyer</Text> for any costs incurred by{' '}
          <Text style={styles.bold}>Buyer</Text> for any inspections or
          certifications obtained according to the terms of the Agreement, and
          any costs incurred by <Text style={styles.bold}>Buyer</Text> for:
        </Text>

        <View style={styles.list}>
          <Text style={styles.listItem}>
            1. Title search, title insurance and/or mechanics' lien insurance,
            or any fee for cancellation;
          </Text>
          <Text style={styles.listItem}>
            2. Flood insurance, fire insurance, hazard insurance, mine
            subsidence insurance, or any fee for cancellation;
          </Text>
          <Text style={styles.listItem}>
            3. Appraisal fees and charges paid in advance to mortgage lender.
          </Text>
        </View>
      </View>
    </View>
  );
};

export default PlannedCommunity;
